import { createTheme } from '@mui/material';
import { palette } from './palette';
import { typography } from './typography';

/*
declare module '@mui/material/Button' {
  interface ButtonPropsSizeOverrides {
    'small-medium': true;
    'medium-large': true;
  }

  interface ButtonPropsColorOverrides {
    tertiary: true;
    white: true;
  }
}
 */
export const theme = createTheme({
  typography,
  palette,
  components: {
    MuiButton: {
      variants: [
        {
          props: { size: 'small-medium' },
          style: {
            fontSize: 15,
            letterSpacing: '0.4px',
            borderRadius: 22,
            height: 40,
            padding: '0 16px',
          },
        },
        {
          props: { size: 'medium-large' },
          style: {
            fontSize: '16px',
            borderRadius: 22,
            height: 44,
            padding: '0 30px',
          },
        },
        {
          props: { color: 'white' },
          style: {
            color: '#fff',
            background: 'transparent',
            border: '1px solid #fff',
            whiteSpace: 'nowrap',
            '&:hover': {
              borderColor: '#03e1b9',
            },
          },
        }
      ],
      styleOverrides: {
        root: ({ ownerState }) => ({
          borderRadius: 28,
          textTransform: 'none',
          lineHeight: '18px',

          ...(ownerState.color === 'primary' && {
            ...(ownerState.variant === 'contained' && {
              boxShadow:
                  '0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.20)',
              '&:hover': {
                background: '#310096',
                boxShadow:
                    '0px 1px 10px 0px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 2px 4px -1px rgba(0, 0, 0, 0.20)',
              },
            }),

            ...(ownerState.variant === 'outlined' && {
              borderColor: '#4700d7',
              color: '#4700d7',
              '&:hover': {
                borderColor: '#1e0040',
                backgroundColor: 'rgba(71, 0, 215, 0.04)',
              },
            }),
          }),

          ...(ownerState.size === 'small' && {
            fontSize: '13px',
          }),
          ...(ownerState.size === 'medium' && {
            fontSize: '15px',
          }),
          ...(ownerState.size === 'large' && {
            fontSize: '17px',
            padding: '15px 24px',
          }),
          ...(ownerState.color === 'warning' && {
            borderColor: '#000',
            backgroundColor: '#ffb703',
            color: '#fff',
          }),
          ...(ownerState.color === 'info' && {
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#1c95ba',
              boxShadow: 'none',
            },
          }),
          ...(ownerState.color === 'success' && {
            borderColor: '#03e1b9',
            backgroundColor: '#03e1b9',
            color: '#000',
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: '#00d09c',
              boxShadow: 'none',
            },
          }),
          ...(ownerState.variant === 'text' && {
            '&:hover': {
              backgroundColor: 'transparent',
              textDecoration: 'underline'
            }
          }),
        }),
      },
    },
    MuiAlertTitle: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          fontSize: '16px',
          lineHeight: '24px',
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          padding: '6px 16px',
          fontSize: '15px',
          lineHeight: 1.45,
          letterSpacing: '0.17px',
          borderRadius: '12px',
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: palette.supportiveBurgundy.main,
          borderRadius: 5,
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: palette.primary.main,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontSize: '17px',
          fontWeight: '300',
          letterSpacing: '0.15px',
          lineHeight: '24px',
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: '12px',
          fontWeight: '400',
          letterSpacing: '0.15px',
          lineHeight: '20px',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          fontSize: '15px',
          lineHeight: '26px',
          fontFamily: 'Nunito Sans',
        },
      },
    },
  },
});
